import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { GroupJoinCall } from '@/pages/messages/components/groups/group-join-call';
import type {
  ChatMediaInfoPartial,
  UseChatMediaCallResult,
} from '@/contexts/chat/scripts/hooks/useChatMediaCall/types';
import { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { ChatContextHooksFull } from '@/contexts/chat/context';
import styles from './index.module.scss';
import AddFriend from './components/addFriend';

export interface ChatProps {
  chat: Chat;
  chatGroup: ChatContextHooksFull['chatGroup'];
  chatMediaCall: UseChatMediaCallResult;
  mediaJoin: (chatMediaInfo?: ChatMediaInfoPartial) => Promise<void>;
}

const ChatPinned = ({ chat, chatMediaCall, mediaJoin, chatGroup }: ChatProps) => {
  return (
    <div className={styles.chatPinned}>
      <AddFriend chat={chat}></AddFriend>
      {chat.category === ChatCategory.GROUP && (
        <GroupJoinCall
          chatGroup={chatGroup}
          chat={chat}
          chatMediaCall={chatMediaCall}
          mediaJoin={mediaJoin}
        />
      )}
    </div>
  );
};
export default ChatPinned;
